export class CustomAlerts
{
    customAlert:
    {
        title:string;
        body:string;
    }[]
}